import 'antd/dist/reset.css';
import { theme } from 'antd';
import { darkBodyColor, lightBodyColor } from '../styles/colors';
const { darkAlgorithm, defaultAlgorithm, getDesignToken } = theme;
export const darkTheme = {
    algorithm: [darkAlgorithm],
    token: {
        colorPrimary: '#E93696',
        colorSuccess: '#00bf9a',
        colorWarning: '#ff9f89',
        colorError: '#fd77a4',
        colorInfo: '#419ef9',
        colorLink: '#E93696',
        colorLinkHover: '#ba54f5',
        colorLinkActive: '#e14eca',
        colorBgBase: darkBodyColor,
        colorBgContainer: '#2e2e48',
        colorBgElevated: '#2e2e48',
        colorBorder: '#44446a',
        colorBorderSecondary: '#525280'
    },
    components: {
        Layout: {
            headerBg: darkBodyColor
        },
        Slider: {
            trackBg: '#92215E',
            dotActiveBorderColor: '#E93696',
            dotSize: 16,
            railSize: 8
        }
    },
};
export const lightTheme = {
    algorithm: [defaultAlgorithm],
    token: {
        colorPrimary: '#b32872ff',
        colorSuccess: '#00bf9a',
        colorWarning: '#ff623fff',
        colorError: '#fd77a4',
        colorInfo: '#419ef9',
        colorLink: '#E93696',
        colorLinkHover: '#ba54f5',
        colorLinkActive: '#e14eca',
        colorBgBase: lightBodyColor,
        colorBgContainer: '#fff',
        colorBgElevated: lightBodyColor,
        colorText: '#4a4a4cff',
    },
    components: {
        Layout: {
            headerBg: lightBodyColor,
            siderBg: lightBodyColor,
            triggerBg: lightBodyColor,
            triggerColor: '#3C1243',
        },
    },
};
export const printTheme = {
    algorithm: [defaultAlgorithm],
    token: getDesignToken()
};
